// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"765":"19b66281","799":"ef7a513d"}[chunkId] + ".chunk.js";
};